import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyCFZYQPnpZR1Izo7AomwqAP4GvvCZtCWfY",
    authDomain: "gamezilla-53154.firebaseapp.com",
    projectId: "gamezilla-53154",
    storageBucket: "gamezilla-53154.appspot.com",
    messagingSenderId: "279678217779",
    appId: "1:279678217779:web:308188c4e74e96c69dbd46",
    measurementId: "G-CYXYTNE7H7",
};

firebase.initializeApp(firebaseConfig);
firebase.firestore();

export default firebase;
